import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import {
	BankAccountRes,
	CreatePersonBankAccountDto,
	VerifyBankIdentifiersDto,
	VerifyBankIdentifiersRes,
} from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';

export const createPersonBankAccountRequest = async ({
	personId,
	body,
}: {
	personId: string;
	body: CreatePersonBankAccountDto;
}): Promise<BankAccountRes | null> => {
	return await makeRequest<ApiV1.Response<BankAccountRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_BANKACCOUNT_POST, {
			personId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	}).then((response) => response.payload ?? null);
};

export const updatePersonBankAccountRequest = async ({
	personId,
	bankAccountId,
	body,
}: {
	personId: string;
	bankAccountId: string;
	body: CreatePersonBankAccountDto;
}): Promise<BankAccountRes | null> => {
	return await makeRequest<ApiV1.Response<BankAccountRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_BANKACCOUNT_BANKACCOUNTID_PUT, {
			personId,
			bankAccountId,
		}),
		method: HTTP_METHOD.PUT,
		body: JSON.stringify(body),
	}).then((response) => response.payload ?? null);
};

export const validatePersonBankAccountRequest = async ({
	personId,
	bankAccountId,
	body,
}: {
	personId: string;
	bankAccountId: string;
	body: VerifyBankIdentifiersDto;
}): Promise<ApiV1.Response<VerifyBankIdentifiersRes>> => {
	return await makeRequest<ApiV1.Response<VerifyBankIdentifiersRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_BANKACCOUNT_BANKACCOUNTID_VALIDATE_POST, {
			personId,
			bankAccountId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	});
};

export const deletePersonBankAccountRequest = async ({
	personId,
	bankAccountId,
}: {
	personId: string;
	bankAccountId: string;
}): Promise<BankAccountRes | null> => {
	return await makeRequest<ApiV1.Response<BankAccountRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_BANKACCOUNT_BANKACCOUNTID_DELETE, {
			personId,
			bankAccountId,
		}),
		method: HTTP_METHOD.DELETE,
	}).then((response) => response.payload ?? null);
};
